import * as d3 from "d3";

export function map_color(color) {
    const dict = {
        "b": "#488FE4",
        "g": "#076B07",
        "r": "#FF4646",
        "y": "#EFEB3A",
        "o": "#F4A460",
        "c": "#64D2F7",
        "p": "#F3BDC6",
        "m": "#9980FA",
        "v": "#C71585",
        "w": "#FFF8DC",
        "k": "#45454A",

    };
    return dict[color];
}

export function map_marker(marker) {
    const dict = {
        "o": d3.symbolCircle,
        "circle": d3.symbolCircle,
        "s": d3.symbolSquare,
        "square": d3.symbolSquare,
        "d": d3.symbolDiamond,
        "diamond": d3.symbolDiamond,
        "+": d3.symbolCross,
        "plus": d3.symbolCross,
        "cross": d3.symbolCross,
        "v": d3.symbolTriangle,
        "triangle": d3.symbolTriangle,
        "*": d3.symbolStar,
        "star": d3.symbolStar,
        "wye": d3.symbolWye,
    };
    for (const [symbol_shortcut, symbol_type] of Object.entries(dict)) {
        if (marker.includes(symbol_shortcut)) return symbol_type;
    }
}

export function get_line_marker(marker) {
    const dict = {
        "--": {"stroke-dasharray": `10, 10`},
        "-.":{"stroke-dasharray": `12, 12, 3, 12`},
        ":":{"stroke-dasharray": `3, 12`},
        "-": {"stroke-dasharray": `1`},
    };
    for (const [linetype_shortcut, style] of Object.entries(dict)) {
        if (marker.includes(linetype_shortcut)) return style;
    }
}